import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { pickIcon } from "./PickIcon";
import type { JSX } from "react";

export interface IndexingAggregateView {
  totalCount: number;
  submittedCount: number;
  failedCount: number;
  skippedCount: number;
  pendingCount: number;
}

export function IndexingBadge(props: { aggregate: IndexingAggregateView | null }) {
  let indexingBadge: JSX.Element;
  const { aggregate } = props;
  if (aggregate === null) {
    indexingBadge = <span>·</span>;
  } else {
    const { totalCount, submittedCount, failedCount, skippedCount, pendingCount } = aggregate;
    const icon = pickIcon(aggregate);
    const counter = `${submittedCount}/${totalCount}`;
    const tooltip = `submitted: ${submittedCount} · failed: ${failedCount} · skipped: ${skippedCount} · pending: ${pendingCount}`;
    indexingBadge = (
    <Tooltip title={tooltip} arrow>
      <Box component="span" display="inline-flex" alignItems="center" gap={0.5}>
        <span>{icon}</span>
        <Typography component="span" variant="caption">
          {counter}
        </Typography>
      </Box>
    </Tooltip>
  );
  }
  return indexingBadge;
}
